import { render, staticRenderFns } from "./contract-approval.container.vue?vue&type=template&id=b781a706&scoped=true&lang=pug"
import script from "./contract-approval.container.vue?vue&type=script&lang=ts"
export * from "./contract-approval.container.vue?vue&type=script&lang=ts"
import style0 from "./contract-approval.container.vue?vue&type=style&index=0&id=b781a706&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b781a706",
  null
  
)

export default component.exports